import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController } from 'ionic-angular';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { CommonProvider } from '../../providers/common/common';

@Component({
  selector: 'sanitizer',
  templateUrl: 'sanitizer.html'
})
export class SanitizerComponent {
  @Input() text: string;
  disp_text: SafeHtml;
  sanitizer_id = 'sanitizer_' + String(Math.floor(Math.random() * 900 + 100));
  rss_ids = [];
  qr_values = [];

  constructor(
    public navCtrl: NavController,
    private sanitizer: DomSanitizer,
    public comProv: CommonProvider
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    let text = this.comProv.thumbnail(changes['text'].currentValue, 1080);
    text = this.setIframe(text);
    text = this.setQr(text);
    this.disp_text = this.sanitizer.bypassSecurityTrustHtml(text);
    this.setRss(text);

    setTimeout(() => {
      this.setClick();
      this.moveQr();
    }, 1)
  }

  setIframe(text) {
    let text_el = document.createElement('div');
    text_el.innerHTML = text;

    let iframe_els = text_el.getElementsByTagName('iframe');
    for (var i=0; i<iframe_els.length; i++) {
      let iframe_src = iframe_els[i].src;
      iframe_els[i].src = this.comProv.replaceUrl(iframe_src, 2);
    }

    return text_el.innerHTML;
  }

  setClick() {
    let sanitizer_el = document.getElementById(this.sanitizer_id);
    if (!sanitizer_el) {
      return;
    }

    let atag_el = sanitizer_el.getElementsByTagName('a');

    let that = this;
    for (var i=0; i<atag_el.length; i++) {
      let href = atag_el[i].getAttribute('href');

      atag_el[i].onclick= function() {
        that.comProv.checkLink(href, that.navCtrl);
        return false;
      };
    }

  }

  setRss(text) {
    let service_data = this.comProv.getService();
    if (!service_data['option']['is_rss_feed']) {
      return;
    }

    if (!text) {
      return;
    }
    let tmp_el = document.createElement('div');
    tmp_el.innerHTML = text;
    let parent_els = tmp_el.getElementsByClassName('parent_rss');
    if (!parent_els.length) {
      return;
    }

    for (let i = 0; i < parent_els.length; i++ ) {
      let parent_el = parent_els[i];
      let rss_id = parent_el.getAttribute('rss_id');
      if (rss_id) {
        this.rss_ids.push(rss_id);
      }
    }
  }

  setQr(text) {
    if (!text) {
      return text;
    }
    let all_el = document.createElement('div');
    all_el.innerHTML = text;
    let display_qr_code_els = all_el.getElementsByClassName('display_qr_code');
    if (!display_qr_code_els.length) {
      return text;
    }

    for (let i = 0; i < display_qr_code_els.length; i++ ) {
      let display_qr_code_el = display_qr_code_els[i];
      let qr_value = '';
      if (display_qr_code_el.getAttribute('value')) {
        qr_value = display_qr_code_el.getAttribute('value');
      }
      this.qr_values.push(this.comProv.replaceUrl(qr_value, 1));

      // 移動用
      display_qr_code_el.innerHTML = '<div class="marker_qr"></div>';
      display_qr_code_el.classList.add('parent_qr_' + i);
    }

    return all_el.innerHTML;
  }

  moveQr() {
    if (!this.qr_values.length) {
      return;
    }
    for (let i = 0; i < this.qr_values.length; i++ ) {
      let parent_qr_el = document.querySelector('.parent_qr_' + i);
      let marker_el = parent_qr_el.querySelector('.marker_qr');
      let place_qr_el = document.querySelector('.place_qr_' + i);
      if (parent_qr_el && marker_el && place_qr_el) {
        parent_qr_el.insertBefore(place_qr_el, marker_el);
      }
      if (marker_el) {
        marker_el.remove();
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/sanitizer/sanitizer.ts